
var stringUtil = require('../string/stringUtil.js');
var logger = require('../logger/logger.js');

var languageLabels = null;
var defaultLanguageCode = "en-GB";
var currentLanguageCode = null;

export async function downloadLanguage(languageCode)
{
    currentLanguageCode = null;
    languageLabels = null;

    var completeUrl = `/labels.json`;
    var labels = await fetch(completeUrl, {cache: "no-store"});
    labels = await labels.json();
    
    if (labels[languageCode] != null)
    {
        languageLabels = labels[languageCode];
        currentLanguageCode = languageCode;
    }
    else if (labels[defaultLanguageCode] != null)
    {
        logger.error(`No language labels found for language: ${languageCode}. Switching over to default language: ${defaultLanguageCode}`);
        languageLabels = labels[defaultLanguageCode];
        currentLanguageCode = defaultLanguageCode;
    }
}

export function getLabel(labelIdentifier)
{
    if (languageLabels == null || stringUtil.isStringNullOrEmpty(languageLabels[labelIdentifier]))
    {
        logger.error(`No translation found for label: ${labelIdentifier}. Inferring the translation`);
        return inferLabelFromIdentifier(labelIdentifier);
    }

    return languageLabels[labelIdentifier];
}

function inferLabelFromIdentifier(labelIdentifier)
{
    return stringUtil.replaceAll(labelIdentifier, "_", " ");
}